import type { ProductVariant, ProductImage, ProductDetail } from '@/types'

export const productName = 'Nuvéa'

export const productVariants: ProductVariant[] = [
    {
        id: 'standard',
        label: 'Standard',
        volume: '50 ml',
        price: 88,
        compareAt: 130
    },
    {
        id: 'travel',
        label: 'Travel',
        volume: '20 ml',
        price: 46,
        compareAt: 68
    }
]

export const productGallery: ProductImage[] = [
    { src: '/images/product-01.png', alt: 'The Nuvéa jar open, cream swirled above the rim', fit: 'contain' },
    { src: '/images/product-02.png', alt: 'The Nuvéa jar from a low angle against a soft neutral backdrop', fit: 'contain' },
    { src: '/images/product-03.png', alt: 'The Nuvéa jar closed, showing the brushed lid', fit: 'contain' },
    { src: '/images/product-04.png', alt: 'The Nuvéa jar beside its replaceable inner pod', fit: 'contain' },
    { src: '/images/product-box.png', alt: 'The Nuvéa outer box, branded and closed, resting in soft daylight', fit: 'cover' },
    { src: '/images/lifestyle-jar-01.png', alt: 'A woman applying Nuvéa to her cheek, jar held beside her face', fit: 'cover' },
    { src: '/images/lifestyle-jar-02.png', alt: 'A woman holding the Nuvéa jar at her shoulder, looking toward the light', fit: 'cover' }
]

export const productSummary = 'One jar, five actives, one step. It replaces the serum, the essence, the day cream and the night cream, because in a twelve-week trial it outperformed the routines it replaced. Refillable glass. No fragrance. Nothing in it that is there to be read rather than used.'

export const productDetails: ProductDetail[] = [
    {
        id: 'shipping',
        title: 'Shipping',
        body: 'Free worldwide, always. Orders leave us within 1-2 working days. Europe arrives in 2-4 days, the US and Canada in 3-6, everywhere else within 7-14 depending on customs. Tracking is sent the moment it ships.'
    },
    {
        id: 'returns',
        title: 'Returns',
        body: 'Thirty days, no conditions worth arguing about. If it is not working for you, email us and we will refund the full purchase price. You do not need to send a half-used jar back for us to believe you.'
    },
    {
        id: 'formula',
        title: 'Full formula',
        body: 'Aqua, Squalane, Glycerin, Niacinamide 4%, Ceramide NP 2%, Palmitoyl Tripeptide-1, Cetearyl Alcohol, Sodium Hyaluronate, Tocopherol, Xanthan Gum, Sodium Phytate, Benzyl Alcohol, Dehydroacetic Acid. No fragrance, no essential oils, no colourant.'
    }
]

export const productAssurances: string[] = [
    'Made in Switzerland',
    'Refillable Glass',
    'Free Worldwide Shipping',
    'Fragrance Free',
    'Never Tested On Animals'
]
